__turbopack_context__.v({
  "answer": "breedFAQ-module-scss-module__at853a__answer",
  "breedFaq": "breedFAQ-module-scss-module__at853a__breedFaq",
  "chevron": "breedFAQ-module-scss-module__at853a__chevron",
  "faqItem": "breedFAQ-module-scss-module__at853a__faqItem",
  "faqItemExpanded": "breedFAQ-module-scss-module__at853a__faqItemExpanded",
  "faqList": "breedFAQ-module-scss-module__at853a__faqList",
  "question": "breedFAQ-module-scss-module__at853a__question",
  "questionButton": "breedFAQ-module-scss-module__at853a__questionButton",
  "title": "breedFAQ-module-scss-module__at853a__title",
});
